const groups = {
  KEYBOARDS: [
    "Arc 65",
    "Arc 75",
    "Arc 80",
    "Field 60",
    "Field 75",
    "Field 98",
    "Mono 68",
    "Mono 84",
    "Studio 65",
    "Studio 80",
    "Air 75",
    "Air 96",
  ],
  MICE: [
    "Trace One",
    "Trace Mini",
    "Trace Ergo",
    "Vector S",
    "Vector Pro",
    "Orbit One",
    "Orbit Air",
    "Glide M",
  ],
  AUDIO: ["Halo H1", "Halo H2", "Echo Buds", "Echo Dock", "Wave Speaker"],
  DESK: ["Form Pad", "Form Stand", "Rail Hub", "Coil Cable", "Desk Mat"],
};
const assets = [
  "01-arc-65-keyboard",
  "02-arc-75-keyboard",
  "03-arc-80-keyboard",
  "04-field-60-keyboard",
  "05-field-75-keyboard",
  "06-field-98-keyboard",
  "07-mono-68-keyboard",
  "08-mono-84-keyboard",
  "09-studio-65-keyboard",
  "10-studio-80-keyboard",
  "11-air-75-low-profile-keyboard",
  "12-air-96-low-profile-keyboard",
  "13-trace-one-symmetrical-mouse",
  "14-trace-mini-compact-mouse",
  "15-trace-ergo-vertical-ergonomic-mouse",
  "16-vector-s-gaming-mouse",
  "17-vector-pro-gaming-mouse",
  "18-orbit-one-productivity-mouse",
  "19-orbit-air-ultralight-mouse",
  "20-glide-m-travel-mouse",
  "21-halo-h1-over-ear-headphones",
  "22-halo-h2-on-ear-headphones",
  "23-echo-buds-wireless-earbuds",
  "24-echo-dock-desktop-speaker",
  "25-wave-speaker-portable-speaker",
  "26-form-pad-aluminum-desk-pad",
  "27-form-stand-laptop-stand",
  "28-rail-hub-usb-c-hub",
  "29-coil-cable-braided-cable",
  "30-desk-mat-wool-desk-mat",
].map((name) => `/images/novakey/products/${name}.png`);
const copy = {
  KEYBOARDS:
    "Gasket soft-touch structure, tri-mode connection and hot-swappable switches.",
  MICE: "Precision sensor, balanced lightweight shell and low-latency wireless control.",
  AUDIO: "Rich detail, calm isolation and seamless switching between devices.",
  DESK: "Machined aluminum, modular geometry and a quieter workspace.",
};
const productDetails = {
  KEYBOARDS: {
    highlights: [
      "Gasket-mounted plate tuned for a soft, controlled keystroke",
      "Hot-swappable sockets support 3-pin and 5-pin mechanical switches",
      "Seamless switching between Bluetooth, low-latency wireless and USB-C",
    ],
    specs: [
      ["Construction", "CNC-machined aluminum enclosure"],
      ["Connectivity", "Bluetooth 5.2 / 2.4 GHz / USB-C"],
      ["Battery", "Up to 160 hours without backlight"],
      ["Compatibility", "macOS, Windows, Linux, iOS and Android"],
      ["Lighting", "South-facing per-key RGB"],
      ["Warranty", "Two-year Somerset Care"],
    ],
    inBox: "Keyboard, braided USB-C cable, wireless receiver, keycap and switch puller, spare accent keys, quick-start guide.",
  },
  MICE: {
    highlights: [
      "Balanced shell geometry developed for long, low-fatigue sessions",
      "Precision optical tracking with adjustable sensitivity",
      "Low-latency wireless performance with multi-device pairing",
    ],
    specs: [
      ["Sensor", "NOVA precision optical sensor"],
      ["Sensitivity", "200–26,000 DPI"],
      ["Polling", "Up to 1,000 Hz"],
      ["Connectivity", "Bluetooth / 2.4 GHz / USB-C"],
      ["Battery", "Up to 100 hours"],
      ["Warranty", "Two-year Somerset Care"],
    ],
    inBox: "Mouse, low-profile wireless receiver, USB-C charging cable, receiver adapter and quick-start guide.",
  },
  AUDIO: {
    highlights: [
      "Custom-tuned drivers for detailed, balanced everyday listening",
      "Fast pairing and effortless switching between two devices",
      "Comfort-focused acoustic design for extended listening sessions",
    ],
    specs: [
      ["Audio", "NOVA custom dynamic driver"],
      ["Connection", "Bluetooth 5.3 and USB-C audio"],
      ["Codecs", "AAC and SBC"],
      ["Microphones", "Dual beam-forming voice array"],
      ["Charging", "USB-C fast charge"],
      ["Warranty", "Two-year Somerset Care"],
    ],
    inBox: "Audio product, USB-C charging cable, protective travel pouch and quick-start guide. Earbud models also include three ear-tip sizes.",
  },
  DESK: {
    highlights: [
      "Purpose-built geometry that keeps essential tools within easy reach",
      "Durable, tactile materials selected to age gracefully",
      "A restrained modular design that works across the Somerset system",
    ],
    specs: [
      ["Materials", "Premium aluminum, textile or polymer by model"],
      ["Finish", "Low-glare graphite"],
      ["Care", "Wipe clean with a soft, lightly damp cloth"],
      ["Compatibility", "Designed for universal desktop setups"],
      ["Packaging", "Plastic-free recycled fiber"],
      ["Warranty", "Two-year limited warranty"],
    ],
    inBox: "Product, protective accessories required for the model, care guide and documentation.",
  },
};
let id = 0;
const products = Object.entries(groups).flatMap(([category, names]) =>
  names.map((title, index) => {
    const n = id++,
      price = 40 + ((n * 17 + index * 9) % 141),
      asset = assets[n];
    return {
      id: n,
      title,
      category,
      price,
      slug: title.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
      description: copy[category],
      ...productDetails[category],
      images: [asset],
      finishes: ["Graphite", "Stone", "Cobalt"],
    };
  }),
);
export default products;
